import {server} from '../Data/BuildEnvironment'
import {HttpRequest} from '../Data/HttpRequest'
import * as PasswordChangeData from '../Entities/PasswordChangeData'

export function submit(data: PasswordChangeData.M): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/password-change`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/PasswordChangeResource.ts